import UserService from "./UserService";
import Kichiri from "./KichiriService";

const CommunicationService = {
	async listCommunications({ clientId, type, source, startDate, endDate, page, limit }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.listCommunications(
				{ clientId, type, source, startDate, endDate, page, limit },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async createCommunication({ clientId, type, source, subject, participants, occurredAt, rawContent, driveFileUrl }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.createCommunication(
				{ clientId, type, source, subject, participants, occurredAt, rawContent, driveFileUrl },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async getCommunication({ communicationId }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.getCommunication(
				{ communicationId },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async deleteCommunication({ communicationId }) {
		let { authToken } = UserService.getUserData();

		try {
			await Kichiri.communication.deleteCommunication(
				{ communicationId },
				{},
				authToken,
			);

			return true;
		} catch (error) {
			console.log(error);
		}

		return false;
	},

	async listMeetRecordings({ clientId }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.listMeetRecordings(
				{ clientId },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async importMeetRecordings({ clientId, fileIds = [] }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.importMeetRecordings(
				{ clientId, fileIds },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async getGoogleAuthUrl() {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.user.connectGoogle({}, {}, authToken);
			return response.data.url;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async getGoogleStatus() {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.user.googleStatus({}, {}, authToken);
			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async disconnectGoogle() {
		let { authToken } = UserService.getUserData();

		try {
			await Kichiri.user.googleDisconnect({}, {}, authToken);
			return true;
		} catch (error) {
			console.log(error);
		}

		return false;
	},

	async scheduleMeeting({ clientId, title, startAt, durationMinutes, description }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.client.createMeeting(
				{ clientId, title, startAt, durationMinutes, description },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async listMeetings({ clientId }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.client.listMeetings(
				{ clientId },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async listUnassigned({ page, limit } = {}) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.listCommunications(
				{ unassigned: true, page, limit },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},

	async assignCommunication({ communicationId, clientId }) {
		let { authToken } = UserService.getUserData();

		try {
			let response = await Kichiri.communication.assignCommunication(
				{ communicationId, clientId },
				{},
				authToken,
			);

			return response.data;
		} catch (error) {
			console.log(error);
		}

		return null;
	},
};

export default CommunicationService;
